var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888B94",
    fillRule: "evenodd",
    d: "M13.481 1.26a3.074 3.074 0 0 1 4.236 4.458l-10.9 10.386a.83.83 0 0 1-.575.23h-3.25a.91.91 0 0 1-.909-.91V12.6c0-.343.142-.67.39-.907zm.324 5.882-7.897 7.525H3.75V12.78l8.057-7.636zm1.207-1.15 1.555-1.481a1.407 1.407 0 0 0-1.94-2.04l-1.61 1.526z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888B94",
    d: "M.833 18.751c0-.46.374-.833.834-.833h16.667a.833.833 0 0 1 0 1.667H1.666a.833.833 0 0 1-.834-.834"
  })));
};
export default SvgEdit;